// extracted by mini-css-extract-plugin
module.exports = {"offersLayoutWarningNote":"offers-layout_offersLayoutWarningNote__1muNu","offersLayoutWarningNoteText":"offers-layout_offersLayoutWarningNoteText__2up-Y"};